import { GitCommitIcon } from '@langchain/untitled-ui-icons';
import { Chip } from '@mui/joy';

import TagList from '@/components/Hub/TagList';
import { TAGS_CATEGORY, tagsByCategory } from '@/components/Hub/constants';
import { GetRepoResponse } from '@/types/schema';

import RepoMetadata from './RepoMetadata';

const RepoDetail = ({
  repoObj,
  inHub,
}: {
  repoObj: GetRepoResponse | undefined;
  inHub: boolean;
}) => {
  const selectedTags = repoObj?.repo?.tags ?? [];
  const allDefaultTags = tagsByCategory.flatMap((category) => category.tags);

  const categories = tagsByCategory.map((category) => {
    return {
      label: category.category,
      selectedTags: selectedTags.filter(
        (tag) =>
          category.tags.includes(tag) ||
          (category.category == TAGS_CATEGORY && !allDefaultTags.includes(tag))
      ),
    };
  });

  return (
    <div className="flex flex-1 flex-col gap-6 p-6">
      {(repoObj?.repo.description || inHub) && (
        <div className="flex flex-col gap-2">
          <label className="flex items-center justify-between text-xs font-medium uppercase text-tertiary">
            Details {inHub && <RepoMetadata inHub={true} />}
          </label>
          <p>{repoObj?.repo.description}</p>
        </div>
      )}

      {categories.map((category) => {
        if (category.selectedTags.length === 0) return null;
        return (
          <div key={category.label} className="flex flex-col gap-2">
            <label className="text-xs font-medium uppercase text-tertiary">
              {category.label}
            </label>
            <div className="flex flex-wrap gap-4">
              <TagList selectedTags={category.selectedTags} />
            </div>
          </div>
        );
      })}

      <div className="flex flex-col gap-2">
        <label className="text-xs font-medium uppercase text-tertiary">
          Commits
        </label>

        <Chip
          size="sm"
          color="neutral"
          variant="outlined"
          startDecorator={<GitCommitIcon className="size-4" />}
          sx={{ borderRadius: 4 }}
        >
          {repoObj?.repo?.num_commits || 0} commit
          {repoObj?.repo?.num_commits === 1 ? '' : 's'}
        </Chip>
      </div>
    </div>
  );
};

export default RepoDetail;
